import './ccf-participant-on-hold.module.scss';
import { SvgIcon, SvgIconProps } from '@mui/material';
/* eslint-disable-next-line */
export interface CcfParticipantOnHoldProps extends SvgIconProps  {}
/**
 * component used to display participant on hold icon  
 * @param props - CcfParticipantOnHoldProps
 * @example - <CcfParticipantOnHold />
 * @returns SVG of participant on hold icon
 */
export function CcfParticipantOnHold(props: CcfParticipantOnHoldProps) {
  return (
    <SvgIcon {...props}>
      <defs>
        <clipPath id="clip-ic_participant_on_hold">
          <rect width="28" height="28" />
        </clipPath>
      </defs>
      <g
        id="ic_participant_on_hold"
        clipPath="url(#clip-ic_participant_on_hold)"
      >
        <g
          id="Group_120171"
          data-name="Group 120171"
          transform="translate(-22 -225.5)"
        >
          <circle
            id="Ellipse_4593"
            data-name="Ellipse 4593"
            cx="12"
            cy="12"
            r="12"
            transform="translate(24 227.5)"
            fill="#707070"
          />
          <g
            id="Group_110256"
            data-name="Group 110256"
            transform="translate(32 234.667)"
          >
            <g id="Group_63" data-name="Group 63" transform="translate(0 0)">
              <path
                id="Path_9"
                data-name="Path 9"
                d="M-156.884-148.559a1.468,1.468,0,0,1-1.376-1.376v-7.914a1.468,1.468,0,0,1,1.376-1.376,1.466,1.466,0,0,1,1.376,1.376v7.914A1.466,1.466,0,0,1-156.884-148.559Z"
                transform="translate(158.26 159.226)"
                fill="#fff"
              />
            </g>
            <g
              id="Group_64"
              data-name="Group 64"
              transform="translate(5.161 0)"
            >
              <path
                id="Path_10"
                data-name="Path 10"
                d="M-152.992-148.559a1.467,1.467,0,0,1-1.376-1.376v-7.914a1.467,1.467,0,0,1,1.376-1.376,1.468,1.468,0,0,1,1.376,1.376v7.914A1.468,1.468,0,0,1-152.992-148.559Z"
                transform="translate(154.368 159.226)"
                fill="#fff"
              />
            </g>
          </g>
        </g>
      </g>
    </SvgIcon>
  );
}

export default CcfParticipantOnHold;
